export function dateToDayMonth(date: Date, locale: string): string {
  const day = date.toLocaleDateString(locale, {
    day: "2-digit"
  });

  const month = date
    .toLocaleDateString(locale, {
      month: "short"
    })
    .replace(/\./g, "")
    .toLowerCase();

  return `${day} ${month}`;
}

export function separateDayAndMonth(
  data: Date,
  currentLang
): {
  day: number;
  month: string;
} {
  const date: Date = data;
  const day = date.getDate();

  const month = date
    .toLocaleDateString(currentLang, {
      month: "short"
    })
    .replace(/\./g, "")
    .toLowerCase()
    .substring(0, 3);

  return { day, month };
}
